import { CommonModule } from '@angular/common';
import { Injector, NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { CmsConfig, ConfigModule, ContextServiceMap, DeferLoadingStrategy } from '@spartacus/core';
import { CmsComponentData, SiteContextComponentService } from '@spartacus/storefront';
import { LanguageFlagComponent } from './language-flag.component';

@NgModule({
  imports: [
    CommonModule,
    MatIconModule,
    NgbDropdownModule,
    ConfigModule.withConfig({
      cmsComponents: {
        CMSSiteContextComponent: {
          component: LanguageFlagComponent,
          providers: [
            {
              provide: SiteContextComponentService,
              useClass: SiteContextComponentService,
              deps: [CmsComponentData, ContextServiceMap, Injector],
            },
          ],
          deferLoading: DeferLoadingStrategy.DEFER,
        },
      },
    } as CmsConfig),
    LanguageFlagComponent,
  ],
  providers: [SiteContextComponentService, LanguageFlagComponent],
})
export class LanguageFlagModule {}
